var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#604DBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#604DBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 5v3l2 1"
  })));
};
export { SvgClock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTNDMTEuNzYxNCAxMyAxNCAxMC43NjE0IDE0IDhDMTQgNS4yMzg1OCAxMS43NjE0IDMgOSAzQzYuMjM4NTggMyA0IDUuMjM4NTggNCA4QzQgMTAuNzYxNCA2LjIzODU4IDEzIDkgMTNaIiBzdHJva2U9IiM2MDREQkMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSA1VjhMMTEgOSIgc3Ryb2tlPSIjNjA0REJDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";